import Cookies from 'js-cookie'

import { loginWithToken } from '../redux/features/authSlice'
import { store } from '../redux/store'
export async function authLoader() {
  const token = Cookies.get('api_token')

  const user = store.getState().auth.user

  if (token) {
    store.dispatch(loginWithToken({ token }))
  }

  return user
}
